import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { ServicesSection } from "@/components/ServicesSection";
import { CitiesSection } from "@/components/CitiesSection";
import { PackagesSection } from "@/components/PackagesSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { HowItWorks } from "@/components/HowItWorks";
import { FaqSection } from "@/components/FaqSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

export default function HomePage() {
  return (
    <div className="bg-obsidian min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <EditorialMarquee />
        <ServicesSection />
        <CitiesSection />
        <PackagesSection />
        <TestimonialsSection />
        <HowItWorks />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
